import React from 'react';
import './Footer.scss';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Remove useTranslation to show footer always in English
  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="footer-copyright">© 2025 The Next Ltd. All Rights Reserved</span>
        <div className="footer-links">
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <a href="mailto:support@ylived.com">support@ylived.com</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
